import type { Flag } from '@prm/shared';

export function FlagList({ flags, empty = 'No flags raised.' }: { flags: Flag[]; empty?: string }) {
  if (flags.length === 0) return <div className="empty">{empty}</div>;

  // Loudest first — a danger flag buried under three info notes is a missed flag.
  const order: Record<Flag['level'], number> = { danger: 0, warn: 1, info: 2 };
  const sorted = [...flags].sort((a, b) => order[a.level] - order[b.level]);

  return (
    <div className="flags">
      {sorted.map((f) => (
        <div key={f.id} className={`flag flag--${f.level}`}>
          <div>
            <div className="flag__title">{f.title}</div>
            <div className="flag__detail">{f.detail}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
